export default {"src":"/_next/static/media/depression-alt.796c467a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};